import { findSwipersInBlocks } from '../parts/ui';

jQuery(document).ready(function () {
    const block = $('.steps-block');
    if (!block.get(0)) return;
    findSwipersInBlocks('.steps-block', {
        spaceBetween: 16,
        breakpoints: {
            1: {
                slidesPerView: 1
            },
            530: {
                slidesPerView: 1.5
            },
            700: {
                slidesPerView: 2
            },
            993: {
                slidesPerView: 3
            },
            1300: {
                slidesPerView: 4
            }
        }
    });
});
